import Trimix from '../pages/Trimix';
import { ROUTES } from './routes.config';

export const TrimixRoutes = {
  path: ROUTES.TRIMIX,
  element: <Trimix />,
};
  
